export const CLICK_RECRUITMENT_TOUCHPOINT_GTM_EVENT = {
  event: 'interaction_click on a link',
  amp_event_name: 'Click on a link',
  event_trigger: 'Super pro touchpoint',
  block_clicked: 'Discover',
};
